var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentImaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4539_356407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8915 11.4783C19.963 10.9959 20 10.5023 20 10C20 8.57779 19.7031 7.22492 19.1679 6H24V11.4783H19.8915ZM18.5217 15.2353C19.0795 14.3294 19.4968 13.3278 19.7434 12.2609H24V17.7391H18.5217V15.2353ZM16.3334 17.7391C16.8471 17.3182 17.3182 16.8471 17.7391 16.3334V17.7391H16.3334ZM12.2609 19.7434C13.3278 19.4968 14.3294 19.0795 15.2353 18.5217H17.7391V24H12.2609V19.7434ZM6 19.1679C7.22492 19.7031 8.57779 20 10 20C10.5023 20 10.9959 19.963 11.4783 19.8915V24H6V19.1679ZM24 18.5217H18.5217V24H24V18.5217Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#FEFEFE",
    stroke: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33333C4 4.59695 4.59695 4 5.33333 4H14.6667C15.403 4 16 4.59695 16 5.33333V14.6667C16 15.403 15.403 16 14.6667 16H5.33333C4.59695 16 4 15.403 4 14.6667V5.33333Z",
    fill: "#338CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.33333C4 5.03333 5.03333 4 5.33333 4H14.6667C14.9667 4 16 4.9 16 5.2V14.6667C16 14.9667 14.9667 16 14.6667 16H5.33333C5.03333 16 4 14.9667 4 14.6667V5.33333ZM15.4 13.6V5.2C15.4 4.9 15.1 4.6 14.8 4.6H5.2C4.9 4.6 4.6 4.9 4.6 5.2V13.6L8.8 8.8L10.6 11.2L11.8 10L15.4 13.6ZM14.125 6.7C14.125 7.38345 13.571 7.9375 12.8875 7.9375C12.204 7.9375 11.65 7.38345 11.65 6.7C11.65 6.01655 12.204 5.4625 12.8875 5.4625C13.571 5.4625 14.125 6.01655 14.125 6.7Z",
    fill: "#47FF9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 4.66667H5.33333C4.96514 4.66667 4.66667 4.96514 4.66667 5.33333V14.6667C4.66667 15.0349 4.96514 15.3333 5.33333 15.3333H14.6667C15.0349 15.3333 15.3333 15.0349 15.3333 14.6667V5.33333C15.3333 4.96514 15.0349 4.66667 14.6667 4.66667ZM5.33333 4C4.59695 4 4 4.59695 4 5.33333V14.6667C4 15.403 4.59695 16 5.33333 16H14.6667C15.403 16 16 15.403 16 14.6667V5.33333C16 4.59695 15.403 4 14.6667 4H5.33333Z",
    fill: "#414042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4539_356407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentImaged);
export default __webpack_public_path__ + "static/media/Experiment_Imaged.baa8d20f3dcd0cda947323aeb59318b5.svg";
export { ForwardRef as ReactComponent };